import React from "react";

interface IProps {
  error: string;
}

function LoginErrorDisplay({ error }: IProps) {
  if (!error) {
    return <></>;
  }
  return (
    <div className="alert alert-danger py-2 mt-3 mb-0" role="alert">
      {error}
    </div>
  );
}

export default LoginErrorDisplay;
